import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./Languages/en";
import fr from "./Languages/fr";
const resources = {
	fr: { translation: fr },
	en: { translation: en },
};
i18n.use(initReactI18next).init({
	lng: "en",
	resources,
});

export default i18n;
